import { Language } from 'store/slices/language-slice';

type Message = {
  [key in Language]: {
    backButtonText: string;
    backButtonTextMobile: string;
  };
};

const messages: Message = {
  en: {
    backButtonText: '← Back',
    backButtonTextMobile: '←',
  },
};

export default messages;
